import { emailSchema } from 'utils/schema';
import * as yup from 'yup';
import { TLoginFormValues } from './LoginForm.types';

export const loginSchema = yup.object<TLoginFormValues>().shape({
  email: emailSchema.required('Email is required'),
  password: yup.string().required('Password is required'),
});
